import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ISbRichtext, ISbStoriesParams } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { ThemeService } from 'src/app/service/theme.service';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    NgFor,
    RouterModule,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
    NgOptimizedImage,
    StoryblokRichTextDirective,
  ],
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
})
export class HeroComponent implements OnInit {
  @ViewChild('bg') bg: any;

  @Input() headline!: string;
  @Input() content!: ISbRichtext;
  @Input() background_mobile!: ISbStoriesParams;
  @Input() background_desktop!: ISbStoriesParams;
  @Input() actions!: any[];
  @Input() eyebrow!: string;
  @Input() aligny_mobile?: string;
  @Input() aligny_desktop?: string;
  @Input() alignx_desktop?: string;
  @Input() alignx_mobile?: string;
  @Input() colour_mobile?: string;
  @Input() colour_desktop?: string;
  @Input() backdrop_mobile?: any;
  @Input() backdrop_desktop?: any;
  @Input() opacity_mobile?: number;
  @Input() opacity_desktop?: number;
  @Input() display_font_face: boolean = false;

  @Input() show_content_mobile: boolean = false;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
  components: any;

  @Input() ideal_height: number = 600;

  bgMobile: string = '';
  bgDesktop: string = '';

  constructor(private themeService: ThemeService) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  ngOnInit(): void {
    this.styleIt();
  }

  styleIt() {
    try {
      this.bgMobile = this.createGradient(
        this.aligny_mobile ?? 'justify-content-start',
        this.alignx_mobile ?? 'align-items-start',
        this.backdrop_mobile,
        this.opacity_mobile ?? 0
      );

      this.bgDesktop = this.createGradient(
        this.aligny_desktop?.replace('-lg', '').split(' ')[0] ??
          'align-items-start',
        this.alignx_desktop?.replace('-lg', '').split(' ')[0] ??
          'justify-content-start',
        this.backdrop_desktop,
        this.opacity_desktop ?? 0
      );
    } catch (err) {
      console.log(err);
    }
  }

  createGradient(
    alignmentY: string,
    alignmentX: string,
    backdrop: any,
    opacity: number
  ) {
    const angle = this.getGradientAngle(alignmentY, alignmentX);
    // If the angle is -1, return a solid background color instead
    if (angle === -1) {
      return this.themeService.hexToRgba(
        backdrop?.color ?? '#000000',
        opacity ?? 0
      );
    }

    return `linear-gradient(${angle}deg, ${this.themeService.hexToRgba(
      backdrop?.color ?? '#000000',
      opacity ?? 0
    )} 0%, rgba(0,0,0,0) 45%)`;
  }

  getGradientAngle(alignmentY: string, alignmentX: string): number {
    // Mapping of alignments to angles
    const angles: { [key: string]: number } = {
      'align-items-start justify-content-start': 45,
      'align-items-center justify-content-start': 0,
      'align-items-end justify-content-start': 315,
      'align-items-start justify-content-center': 90,
      'align-items-center justify-content-center': -1, // solid color
      'align-items-end justify-content-center': 270,
      'align-items-start justify-content-end': 135,
      'align-items-center justify-content-end': 180,
      'align-items-end justify-content-end': 225,
    };

    const key = `${alignmentX} ${alignmentY}`;
    return angles[key] ?? -1; // Default to -1 for unrecognized combinations
  }
}
